import api from '../api'

export const postModel = (params) => api.post('/admin/machines/models', params)

export const putModel = ({ id, ...params }) => api.put(`/admin/machines/models/${ id }`, params)

export const deleteModel = ({ id }) => api.delete(`/admin/machines/models/${ id }`)
